import { StreetType, StreetTypeRepository, StreetTypeRepositoryError } from '@/Domain/Localization/StreetType'
import { LanguageCode } from '@/Domain/Localization'
import { StreetTypeFactory } from '@/Domain/Localization/StreetType/StreetTypeFactory'
import { AxiosStreetTypeJsonData } from './AxiosStreetTypeJsonData'
import { ApiClient, Api500Error } from '@/Domain/ApiClient'

export class AxiosStreetTypeRepository implements StreetTypeRepository {
  private _factory: StreetTypeFactory<AxiosStreetTypeJsonData>
  private _apiClient: ApiClient

  constructor (apiClient: ApiClient, factory: StreetTypeFactory<AxiosStreetTypeJsonData>) {
    this._factory = factory
    this._apiClient = apiClient
  }

  async byLanguageCode (languageCode: LanguageCode): Promise<StreetType[]> {
    const url = '/sobree/api/localization/street-type/' + languageCode
    try {
      const response = await this._apiClient.makeGetRequest(url, {})
      const procedures: StreetType[] = []
      for (const item of response.data.data.streetType) {
        const procedure = this._factory.makeStreetType(item)
        procedures.push(procedure)
      }
      return procedures
    } catch (error) {
      if (error instanceof Api500Error) {
        throw new StreetTypeRepositoryError('Server not responding')
      }
      return Promise.reject(error)
    }
  }
}
